<template>
    <div class="data-picker-container">
        <v-menu
            lazy
            offset-y
            full-width
            ref="menu"
            transition="scale-transition"
            min-width="290px"
            :close-on-content-click="false"
            :return-value.sync="date"
            :nudge-right="40"
			:style="`color:${$appColors.info}`"
            v-model="menu"
        >
        <template slot="activator" slot-scope="{ on }">
			<label :style="`color:${$appColors.info}`">{{label}}</label>
			<input
				readonly
				prepend-icon="event"
				class="new-diagnosis-input"
				v-on="on"
				ref="flatpickr"
			>
        </template>
      </v-menu>
	  	<input
			class="new-diagnosis-input"
			v-model="date"
			readonly
			:style="{ display: 'none' }"
		>
    </div>
</template>
<script>
import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.min.css';
import 'flatpickr/dist/l10n/es';

function mounted() {
	this.initFlatpickr();
}

function created() {
}

function initFlatpickr() {
	flatpickr(this.$refs.flatpickr, {
		dateFormat: 'Y-m-d H:i',
		enableTime: true,
		locale: 'es',
		// altInput: true,
		defaultDate: this.$props.initialDate,
		onChange: (selectedChange) => {
			this.date = selectedChange[0];
			const formattedDate = this.date.toISOString().replace('T', ' ').replace(/\.\d+Z$/, '');
			this.$emit('input', formattedDate);
		},
	});
}

// function setDate(date) {
// 	this.date = date;
// 	this.$emit('input', date);
// }

function data() {
	return {
		date: '',
		menu: false,
	};
}

export default {
	name: 'app-date-hour',
	inheritAttrs: false,
	data,
	mounted,
	created,
	components: {
		flatpickr,
	},
	methods: {
		// setDate,
		initFlatpickr,
	},
	props: {
		allowedDates: {
			type: Function,
		},
		label: {
			type: String,
		},
		initialDate: {
			type: String,
			default: '',
		},
	},
};
</script>
<style lang="scss" scoped>
.data-picker-container {
	label {
		font-size: size(small);
	}
}
</style>


// WEBPACK FOOTER //
// src/components/shared/app-date-hour.vue